import React, { useState, useEffect } from "react";

export const svg = `<svg width="84" height="85" viewbox="0 0 84 85" viewBox="0 0 84 85" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.391357" width="84" height="84" rx="42" fill="#08090D"></rect><g><path d="M49.9557 18.7664C46.9502 18.7664 44.5164 21.1707 44.5164 24.14C44.5164 27.1092 46.9502 29.5136 49.9557 29.5136C52.9612 29.5136 55.395 27.1092 55.395 24.14C55.395 21.1707 52.9612 18.7664 49.9557 18.7664ZM33.0512 24.7369C32.1164 24.7228 31.2963 25.2873 30.7404 25.738L23.2749 31.7964C22.26 32.6199 22.1216 34.0949 22.9551 35.0976C23.7883 36.1002 25.2638 36.2546 26.2793 35.4311L32.7136 30.1983L37.6727 31.2166L29.9053 43.0694L24.4304 49.918C20.5559 49.7659 16.9815 49.3101 13.6232 49.0047C12.0432 48.8608 10.6582 49.9897 10.5125 51.551C10.3669 53.1122 11.5068 54.5362 13.0899 54.6417C17.0278 54.9036 20.9724 55.1529 24.9108 55.4143C25.9253 55.4817 26.6712 55.4645 27.3814 54.9228C27.6921 54.6856 27.9178 54.3869 28.1634 54.08C29.6041 52.28 32.4825 48.6716 32.4825 48.6716L40.3214 54.1326L36.1801 62.0171C35.473 63.3601 35.994 65.0064 37.3533 65.7049C38.7126 66.4034 40.3794 65.8887 41.0861 64.5458L46.2229 54.782C46.405 54.4359 46.4721 54.0549 46.5253 53.6931C46.6729 52.6892 46.317 51.6564 45.423 51.0237L38.0285 45.7909L44.1251 36.5716L46.8445 41.3483C47.2476 42.053 47.9899 42.5555 48.8708 42.5775C52.3333 42.663 59.2514 42.8233 59.2514 42.8233C60.5643 42.8558 61.6537 41.8375 61.6867 40.5404C61.7197 39.2434 60.6889 38.167 59.376 38.1344L51.2526 37.9412L47.1286 30.7061C46.4509 29.5161 44.4413 27.0274 42.6849 26.6672L33.4605 24.7715C33.3233 24.7433 33.1845 24.7389 33.0512 24.7369Z" fill="currentColor"></g><path><path d="M59.3906 19.2585C59.3906 17.8994 60.4924 16.7976 61.8516 16.7976C63.2107 16.7976 64.3125 17.8994 64.3125 19.2585V67.4929C64.3125 68.8521 63.2107 69.9539 61.8516 69.9539C60.4924 69.9539 59.3906 68.8521 59.3906 67.4929V19.2585Z" fill="currentColor"></path></g></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
